const EventEmitter = require('events').EventEmitter
var moment = require('moment')
moment.locale('it')
import axios from './tAxios'
import storage from './tStorage'

import dbItem from './dbItem'


class centro{
   constructor (args) {
      this.event = new EventEmitter()
      this.moment = moment

      this.profile = new dbItem({database:'sin_inn',table:'centro'})
      this.referente = new dbItem({table:'contatto'})
      this.struttura = new dbItem({table:'struttura'})

      this.profile.event.on('loaded', async () =>{
         storage.save('centro',this.profile.row.id)      
         this.profile.row.refisdir = 0
         await this.init() 
      })

      this._contatto = []
      this._paziente = []
      this._schedeinlavorazione = []
      this._schedechiuse = []
      this._errorVonNumber = []
      this._struttura = {}

      this.pazienteCerca=''
      this.pazienteAnno=moment().format('YYYY')

      this.lastSGA
      this.lastGRUPPO
      
      this.letto=false
      return this
   }

   async getReferente(){
      axios.query('fetchOne',`SELECT id FROM contatto WHERE centro=→id AND ruolo=10 ORDER BY id`,{id: this.profile.row.id}).then((response) =>  {
         this.referente.load(response.result)
         return new Promise((resolve, reject) => {resolve("Fatto")})
      })
   }

   async getStruttura(){
      axios.query('fetchRow',`SELECT * FROM struttura WHERE id=→codiceministeriale ORDER BY id`,{codiceministeriale: this.profile.row.codiceministeriale},this,'_struttura')
      return new Promise((resolve, reject) => {resolve("Fatto")})
   }
   
   async getContatti(){
      axios.query('fetchAll',`SELECT * FROM contatto WHERE centro=→id AND ruolo<11 ORDER BY cognome,nome`,{id: this.profile.row.id},this,'_contatto')
      return new Promise((resolve, reject) => {resolve("Fatto")})
   }
   
   async getPaziente(){
      axios.query('fetchAll',`SELECT * FROM paziente WHERE centro=→id AND id>0 AND id>0 ORDER BY ncartellaclinica,cognome,nome`,{id: this.profile.row.id},this,'_paziente')
      return new Promise((resolve, reject) => {resolve("Fatto")})
   }
   
   async getSchedeInlavorazione(){
      axios.query('fetchAll',`SELECT * FROM paziente WHERE centro=→id AND chiusoil=0 AND id>0 ORDER BY ncartellaclinica,cognome,nome`,{id: this.profile.row.id},this,'_schedeinlavorazione')
      return new Promise((resolve, reject) => {resolve("Fatto")})
   }
   
   async getSchedeChiuse(){
      axios.query('fetchAll',`SELECT * FROM paziente WHERE centro=→id AND chiusoil>0 AND id>0 ORDER BY ncartellaclinica,cognome,nome`,{id: this.profile.row.id},this,'_schedechiuse')
      return new Promise((resolve, reject) => {resolve("Fatto")})
   }
   
   async checkVonNumber(){
      axios.query('fetchAll',`SELECT vonnumber,count(*) AS totale FROM paziente WHERE centro=→id AND vonnumber>0 AND id>0 GROUP BY vonnumber HAVING count(*)>1 ORDER BY vonnumber,ncartellaclinica,cognome,nome`,{id: this.profile.row.id},this,'_errorVonNumber')
      return new Promise((resolve, reject) => {resolve("Fatto")})
   }

   async init(){
      await this.getReferente()
      await this.getStruttura()
      await this.getContatti()
      await this.getPaziente()
      await this.getSchedeChiuse()
      await this.getSchedeInlavorazione()
      await this.getSchedeInlavorazione()
      await this.checkVonNumber()

      return new Promise((resolve, reject) => {
         console.log("INIT finito per "+this.profile.row.nome)
         resolve("Fatto")
      })
   }

   settimana36(birthday,gaweeks,gadays){
      return this.moment(birthday).subtract(gaweeks*7+gadays, 'days').add(36*7,'days')
   }
   giorno28(birthday){
      return this.moment(birthday).add(27,'days')
   }
   giorno3(birthday){
      return this.moment(birthday).add(2,'days')
   }
   tipoPaziente(bwgt,gaweeks,gadays){
      this.lastGRUPPO = (bwgt<1501 || parseInt(gaweeks)<32) ? 1 : 2
      if(parseInt(gaweeks)>36 && bwgt>1500) 
         this.lastGRUPPO = 0


      

   
      return this.lastGRUPPO
   }
   bmi(pmadre,hmadre){
      let bmi = pmadre/((hmadre/100)*(hmadre/100))
      let esito = 'Non conosciuto'
      if(bmi < 16.00){
         esito = 'Grave magrezza'
      }else if(bmi > 15.99 && bmi < 18.50){
         esito = 'Sottopeso'
      }else if(bmi > 18.49 && bmi < 25.00){
         esito = 'Normopeso'
      }else if(bmi > 24.99 && bmi < 30.00){
         esito = 'Sovrappeso'
      }else if(bmi > 29.99 && bmi < 35.00){
         esito = 'Obesità di I classe'
      }else if(bmi > 34.99 && bmi < 40.00){
         esito = 'Obesità di II classe'
      }else if(bmi > 39.99){
         esito = 'Obesità di III classe'
      }

      return esito+" ("+parseFloat(bmi).toFixed(1)+")"
   }
   async sga(sex,primogenito,gaweeks,bwgt){
      console.log(sex+' :: '+gaweeks+' :: '+bwgt)
      return new Promise((resolve, reject) => {
         axios.query('fetchOne',`SELECT sga(→sex,→primogenito,→gaweeks,←bwgt)`,{sex:sex,primogenito:primogenito,bwgt:bwgt,gaweeks:gaweeks}).then((response) => {
          this.lastSGA = (response.result==false) ? -7 : response.result
          resolve(response.result)
        })
      })
   }


   checkEmail(emailCheck,idContatto){
      return new Promise((resolve, reject) => {
         axios.query('fetchOne',`SELECT email FROM contatto WHERE email=→email AND id!=→id AND centro>0 LIMIT 1`,{email:emailCheck,id:idContatto}).then((response) => {
          var controllo = (response.result == emailCheck) ? false : true
          resolve(controllo)
        })
      })
   }

   checkMinisteriale(ministerialeCheck,idCentro){
      return new Promise((resolve, reject) => {
         console.log("CODICE: " +ministerialeCheck)
         axios.query('fetchOne',`SELECT codiceministeriale FROM centro WHERE codiceministeriale=→codiceministeriale AND id!=→id LIMIT 1`,{codiceministeriale:ministerialeCheck,id:idCentro}).then((response) => {
          var controllo = (response.result == ministerialeCheck) ? false : true
          resolve(controllo)
        })
      })
   }

   checkCartella(cartellaCheck,datacartellaCheck,idCentro,idPaziente){
      return new Promise((resolve, reject) => {
         console.log("CARTELLA: " +cartellaCheck)
         axios.query('fetchOne',`SELECT ncartellaclinica FROM paziente WHERE ncartellaclinica=→ncartellaclinica AND id>0 AND YEAR(dataricovero)=YEAR(→datacartella)  AND centro=→centro AND id!=→idLIMIT 1`,{ncartellaclinica:cartellaCheck,datacartella:datacartellaCheck,centro:idCentro,id:idPaziente}).then((response) => {
          var controllo = (response.result == cartellaCheck) ? false : true
          resolve(controllo)
        })
      })
   }

   checkVonnumber(vonnumberCheck,idCentro,idPaziente){
      return new Promise((resolve, reject) => {
         console.log("CARTELLA: " +vonnumberCheck)
         axios.query('fetchOne',`SELECT ncartellaclinica FROM paziente WHERE ncartellaclinica=→ncartellaclinica AND id>0 AND centro=→centro AND id!=→id LIMIT 1`,{ncartellaclinica:vonnumberCheck,centro:idCentro,id:idPaziente}).then((response) => {
          var controllo = (response.result == vonnumberCheck) ? false : true
          resolve(controllo)
        })
      })
   }

   



}
export default new centro
